import { lenis } from "./lenis";

export default (ref) => {
  if (!ref.addToCartFlow) return;

  const mobileBuyButtons = ref.addToCartFlow
    .map((el) => el.querySelector("[data-sticky-bottom]"))
    .filter(Boolean);

  const teardown = lenis.on("scroll", (e) => {
    if (window.innerWidth > 768) return;

    mobileBuyButtons.forEach((button) => {
      const { parentElement } = button;
      const { bottom } = parentElement.getBoundingClientRect();

      button.style.transition = 'transform 200ms';
      
      if (bottom < 0) {
        button.style.transform = `translateY(-3.5rem)`;
      } else {
        button.style.removeProperty("transform");
      }
    });
  });

  const allBuyButtons = [
    ...ref.addToCartFlow.map((element) => [
      ...element.querySelectorAll('[type="submit"]'),
    ]),
  ].flat(3);

  function handleAddToCartLoading(e) {
    const isLoading = e.detail;

    allBuyButtons.forEach((button) => {
      button.classList.toggle("opacity-50", isLoading);
    });
  }

  window.addEventListener(
    "a-la-cart.add-to-cart-loading",
    handleAddToCartLoading,
  );

  return teardown;
};
